<template>
  <div class="relative">
    <div
      v-if="data.title"
      class="absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 ui-text-m font-medium text-white border border-white px-5 py-3 rounded-[100%] bg-dark-3"
    >
      <NuxtLink
        v-if="data.link"
        :to="localePath(data.link)"
        target="_blank"
        class="block"
      >
        {{ data.title }}
      </NuxtLink>
      <span v-else>
        {{ data.title }}
      </span>
    </div>
    <div
      v-if="blockData?.pictures?.length"
      class="grid grid-cols-2 lg:grid-cols-4"
    >
      <div
        v-for="(picture, idx) in blockData.pictures.slice(0, itemsLimit)"
        :key="`${picture?.permalink}-${idx}`"
        class="aspect-1 cursor-pointer"
      >
        <NuxtLink :to="localePath(picture?.url)" target="_blank">
          <UiLazyImg
            class="h-full w-full"
            :src="picture?.url || '/images/no-image.webp'"
            :alt="'image'"
            img-classes="object-cover"
          />
        </NuxtLink>
      </div>
    </div>
    <div v-else class="grid grid-cols-2 lg:grid-cols-4">
      <div
        v-for="(_, idx) in itemsLimit"
        :key="idx"
        class="aspect-1 cursor-pointer"
      >
        <UiLazyImg
          class="h-full w-full"
          :src="'/images/no-image.webp'"
          :alt="`image-${idx}`"
          img-classes="object-cover"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ArticlesBlockData, BlockInstagramContent } from "ecom-types";

defineProps<{ data: ArticlesBlockData; blockData: BlockInstagramContent }>();

const localePath = useLocalePathPolyfill();
const itemsLimit = 4;
</script>
